export type Agent = {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  userName: string;
  identifier: string;
  agentNumbers: string[];
  pendingAgentConnections: number[];
  connectedAgents: number[];
  picture: string;
  branch?: string;
  isTerminated?: boolean;
};

export type AgentWithConnections = Agent & {
  connections: Agent[];
};

export const getFullName = (user: {firstName?: string; lastName?: string}) => `${user.firstName} ${user.lastName}`;
